import {type IdName, type NameEnabled} from '$lib/models/types';

export enum ColumnNames {
  Id = 'Id',
  ClientName = 'ClientName',
  CreateDate = 'CreateDate',
  ClientStatus = 'ClientStatus',
  ConnectionType = 'ConnectionType',
}

export const ClientStatuses: IdName[] = [
  { id: 0, name: 'Inactive' },
  { id: 1, name: 'Active' },
  { id: 2, name: 'Test' },
];

export const AliiOCRTypes: IdName[] = [
  { id: 1, name: 'Nanonets' },
  { id: 2, name: 'Azure OCR' },
];

export const DefaultAliiOCRType = 1;

export interface GetClientByIdResponse {
  id: number;
  clientName: string | undefined;
  clientKey: string | undefined;
  clientStatus: number
  connectionTypeId: number;
  exportTypeId: number;
  aliiOCRType: number;
  nanonetModelKey: string | undefined;
  location: string | undefined;
  language: number | undefined;
  domains: IdName[];
  menuConfigs: string[];
  notificationConfigs: GetBridgeClientNotification[];
  clientNotes: GetClientNoteResponse[];
  organisationId: string | undefined;
  organisationName: string | undefined;
}

export interface OrganisationSearchResult {
  id: string;
  name: string;
}

export interface GetBridgeClientNotification {
  id: number;
  aliiNotificationCategoryId: number;
  inApp: boolean | undefined;
  email: boolean | undefined;
  both: boolean | undefined;
}

export interface PutClientRequest {
  id: number;
  clientName: string | undefined;
  clientStatus: number;
  connectionTypeId: number;
  exportTypeId: number;
  aliiOCRType: number;
  nanonetModelKey: string | undefined;
  location: string | undefined;
  language: number | undefined;
  domains: IdName[];
  menuConfigs: UpdateMenuConfig[];
  notificationConfigs: PutBridgeClientNotificationRequest[];
}

export interface UpdateMenuConfig {
  name: string;
  enabled: boolean;
  applyToAllUser?: boolean;
}

export interface PutBridgeClientNotificationRequest {
  id: number | undefined;
  aliiNotificationCategoryId: number;
  inApp: boolean | undefined;
  email: boolean | undefined;
  applyToAllUsers: boolean | undefined;
}

export interface CreateClientRequestStore {
  clientName: string | undefined;
  clientStatus: number;
  connectionTypeId: number | undefined;
  exportTypeId: number | undefined;
  aliiOCRType: number;
  initialUserDetails: InitialUserDetails;
  domains: string[];
  menuConfigs: NameEnabled[];
  createNewOrganisation: boolean;
  organisationId: string | undefined;
  organisationName: string | undefined;
  location: string | undefined;
}

export interface CreateClientRequest {
  clientName: string | undefined;
  clientStatus: number;
  connectionTypeId: number | undefined;
  exportTypeId: number | undefined;
  aliiOCRType: number;
  initialUserDetails: InitialUserDetails;
  domains: string[];
  menuConfigs: string[];
  organisationId: string | undefined;
  organisationName: string | undefined;
  location: string | undefined;
}

export interface GetClientNoteResponse {
    id: number;
    noteDescription: string | undefined;
    noteCreator: string | undefined;
    createDate: Date | undefined;
}
export interface CreateClientNoteRequest {
    id: number;
    noteDescription: string | undefined;
    noteCreator: string | undefined;
    createDate?: Date | null;
    clientId: number | null;
}

export interface DeleteClientNoteRequest {
    id: number;
    clientId: number | null;
    currentUserDisplayName: string;
}
export interface InitialUserDetails {
  username: string | undefined;
  password: string | undefined;
  name: string | undefined;
}

export enum CreateClientSteps {
  ClientDetails,
  InitialUser,
  Permission,
  Review,
}
